import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import InstagramFeed from '../components/InstagramFeed';

const News = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadNews();
    }, []);

    const loadNews = async () => {
        const { data, error } = await supabase
            .from('news')
            .select('*')
            .order('date', { ascending: false })
            .limit(20);

        if (!error && data) {
            setNews(data);
        }
        setLoading(false);
    };

    if (loading) {
        return (
            <div className="text-center py-12">
                {/* CHANGED: text-gray-600 → dark:text-gray-400 */}
                <div className="text-lg text-gray-600 dark:text-gray-400">Loading news...</div>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            {/* CHANGED: heading had no color — defaults to black, invisible on dark bg */}
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">League News</h1>

            {news.length > 0 ? (
                news.map(article => (
                    // CHANGED: bg-white → dark:bg-gray-800
                    <div key={article.id} className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
                        {/* CHANGED: no color on h2 — added dark:text-white */}
                        <h2 className="text-2xl font-bold mb-2 text-gray-900 dark:text-white">{article.title}</h2>
                        {/* CHANGED: date text dark counterpart */}
                        <p className="text-gray-600 dark:text-gray-400 text-sm mb-3">
                            {new Date(article.date).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}
                        </p>
                        {/* CHANGED: body text dark counterpart */}
                        <p className="text-gray-700 dark:text-gray-300 whitespace-pre-line">{article.content}</p>
                    </div>
                ))
            ) : (
                // CHANGED: bg-white → dark:bg-gray-800; text colors need dark counterparts
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-12 text-center">
                    <div className="text-6xl mb-4">📰</div>
                    <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">No News Yet</h2>
                    <p className="text-gray-600 dark:text-gray-400">
                        Check back soon for league updates, game recaps, and announcements!
                    </p>
                </div>
            )}

            {/* Instagram Section */}
            {/* CHANGED: outer card bg-white → dark:bg-gray-800; heading dark:text-white */}
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
                <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Follow the Action</h2>

                {/* NOTE: The gradient banner is intentionally hardcoded — it's a brand/decorative
            element and should look the same in both modes. No changes needed here. */}
                <div className="bg-gradient-to-br from-pink-500 to-purple-600 rounded-lg p-8 text-center text-white">
                    <div className="text-6xl mb-3">📸</div>
                    <h3 className="text-2xl font-bold mb-2">@muqalabhoops</h3>
                    <p className="mb-6">Game highlights • Player spotlights • League updates</p>
                    <a
                        href="https://instagram.com/muqalabhoops"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-white text-purple-700 px-8 py-3 rounded-lg font-semibold hover:bg-purple-50 transition"
                    >
                        Follow on Instagram
                    </a>
                </div>
                <div className="mt-12">
                    <InstagramFeed limit={6} />
                </div>
            </div>
        </div>
    );
};

export default News;